import { createSlice } from "@reduxjs/toolkit";
import {
  getStockReport,
  getStockEntryReport,
  getStockDistributionReport,
} from "./actions/stockAction.js";

const initialState = {
  loading: false,

  stockReport: null,
  totalByStockReport: 0,
  stockReportFilters: {},
  stockReportPageState: { page: 1, pageSize: 50 },

  stockEntryReport: null,
  totalByStockEntryReport: 0,
  stockEntryReportFilters: {},
  stockEntryReportPageState: { page: 1, pageSize: 50 },

  stockDistributionReport: null,
  totalByStockDistributionReport: 0,
  stockDistributionReportFilters: {},
  stockDistributionReportPageState: { page: 1, pageSize: 50 },

  stockDetail: null,
};

export const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    setStockReportFilters: (state, action) => {
      const { payload } = action;
      state.stockReportFilters = payload || {};
    },
    resetStockReportFilters: (state) => {
      state.stockReportFilters = {};
    },
    setStockReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.stockReportPageState = {
          ...state.stockReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.stockReportPageState = {
          ...state.stockReportPageState,
          pageSize,
        };
      }
    },

    setStockEntryReportFilters: (state, action) => {
      const { payload } = action;
      state.stockEntryReportFilters = payload || {};
    },
    resetStockEntryReportFilters: (state) => {
      state.stockEntryReportFilters = {};
    },
    setStockEntryReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.stockEntryReportPageState = {
          ...state.stockEntryReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.stockEntryReportPageState = {
          ...state.stockEntryReportPageState,
          pageSize,
        };
      }
    },

    setStockDistributionReportFilters: (state, action) => {
      const { payload } = action;
      state.stockDistributionReportFilters = payload || {};
    },
    resetStockDistributionReportFilters: (state) => {
      state.stockDistributionReportFilters = {};
    },
    setStockDistributionReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.stockDistributionReportPageState = {
          ...state.stockDistributionReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.stockDistributionReportPageState = {
          ...state.stockDistributionReportPageState,
          pageSize,
        };
      }
    },
    setStockEntryReportDetail: (state, action) => {
      const stock = state.stockEntryReport.find(
        (_stock) => _stock.id === action.payload
      );
      state.stockDetail = stock;
    },
    setStockDistributionReportDetail: (state, action) => {
      const stock = state.stockDistributionReport.find(
        (_stock) => _stock.id === action.payload
      );
      state.stockDetail = stock;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStockReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockReport.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.stockReport = data;
        state.totalByStockReport = count;
      })
      .addCase(getStockReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getStockEntryReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockEntryReport.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.stockEntryReport = data;
        state.totalByStockEntryReport = count;
      })
      .addCase(getStockEntryReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getStockDistributionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockDistributionReport.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.stockDistributionReport = data;
        state.totalByStockDistributionReport = count;
      })
      .addCase(getStockDistributionReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {

  resetStockReportFilters,
  setStockReportFilters,
  setStockReportPage,

  resetStockEntryReportFilters,
  setStockEntryReportFilters,
  setStockEntryReportPage,

  resetStockDistributionReportFilters,
  setStockDistributionReportFilters,
  setStockDistributionReportPage,

  resetStockEntryFilters,
  setStockEntryFilters,
  setStockEntryPage,

  setStockDistributionFilters,
  resetStockDistributionFilters,
  setStockDistributionPage,

  setStockEntryReportDetail,
  setStockDistributionReportDetail,
} = stockSlice.actions;

export default stockSlice.reducer;
